import { Container } from "typescript-ioc";
import { ReadyHelper } from "Events/Scripts/ReadyHelper";
import { UiComponentFactory } from "Ui/Scripts/UiComponentFactory";
import { DeliveryChannels } from "./DeliveryChannels";

Container.get(ReadyHelper).bindInitCodeBlocksReady(() =>
    Container.get(UiComponentFactory).createBase(DeliveryChannels, "#delivery-page")
);
